import { connect, useSelector } from 'react-redux';
import { RootState } from 'store/configureStore';
import { NotRequiredRepaymentStrategy, TIORepaymentStrategy } from 'modules/cm/pages/CaseDetailsPage/subPages';
import { CaseDetails } from 'modules/cm/pages/CaseDetailsPage/CaseDetailsPage.types';
import useProductType from 'modules/cm/hooks/useProductType';
import { CaseId } from 'modules/cm/api/cases/types';
import { RepaymentStrategy } from '../RepaymentStrategy';
import Spinner from 'shared/Spinner/Spinner';
import getRepaymentDataSelector from '../store/selectors/getRepaymentDataSelector';
import getInitialRepaymentDataSelector from '../store/selectors/getInitialRepaymentDataSelector';
import { State } from 'modules/cm/store/cases/types';
import { ProductRepaymentTypes } from 'domain/Product';

const state = (state: RootState) => {
  return {
    // repaymentStrategyState: state.repaymentStrategy,
    // repaymentStrategy: getRepaymentStrategyData(state),
    initialRepaymentStrategy: getInitialRepaymentDataSelector(state),
    repaymentStrategy: getRepaymentDataSelector(state),
    isFormLoading: false,
  };
};
const dispatchers = {};

interface ContainerProps {
  resources: CaseDetails['resources'];
  caseId: CaseId;
  initialRepaymentStrategy: RepaymentStrategy;
  repaymentStrategy: RepaymentStrategy;
  isFormLoading: boolean;
}

const Container = ({
  resources,
  caseId,
  initialRepaymentStrategy,
  repaymentStrategy,
  isFormLoading,
}: ContainerProps) => {
  const { isTIO } = useProductType();
  const repaymentType = useSelector(
    ({ currentCase }: { currentCase: State }) => currentCase.data?.case.loanDetails.productRepaymentType,
  );

  return isTIO && repaymentType === ProductRepaymentTypes.INTEREST_ONLY ? (
    isFormLoading ? (
      <Spinner />
    ) : (
      <TIORepaymentStrategy
        caseId={caseId}
        resources={resources}
        initialRepaymentStrategy={initialRepaymentStrategy}
        repaymentStrategy={repaymentStrategy}
      />
    )
  ) : (
    <NotRequiredRepaymentStrategy resources={resources} />
  );
};

export default connect(state, dispatchers)(Container);
